import { IInitialisable } from "../../interfaces/IInitialisable";
import { documentReady } from '../../utils/dom/ready';

export class IconsTagHelper implements IInitialisable {
	private windowHelper = window;
	private documentHelper = document;
	private documentReady = documentReady;

	// tested
	public Init() {
		if(this.windowHelper.requestIdleCallback !== undefined){
			this.windowHelper.requestIdleCallback(
				() => {
					this.searchDomAndInit();
					this.windowHelper.addEventListener("data-cmpt-tag-helper-refresh", () => this.searchDomAndInit());
				},
				{ timeout: 1000 }
			);
		}
		else{
			this.documentReady().then(() => {
				this.searchDomAndInit();
				this.windowHelper.addEventListener("data-cmpt-tag-helper-refresh", () => this.searchDomAndInit());
			})
		}
	}

	// tested
	private searchDomAndInit() {
		const selectors = [`[data-cmpt].cmpt a:not([data-cmpt-tag-helper*="icon-initialised"])`, `[data-cmpt].cmpt button:not([data-cmpt-tag-helper*="icon-initialised"])`];
		const els = Array.from(this.documentHelper.querySelectorAll<HTMLElement>(selectors.join(",")));
		els.forEach((el) => this.injectIconsIntoElementsIfRequired(el));
	}

	// tested
	private injectIconsIntoElementsIfRequired(el: HTMLElement) {
		el.setAttribute("data-cmpt-tag-helper", "icon-initialised");
		const beforeIconHtml = this.generateIconHtmlOrDefaultToEmptyString(el, ":before");
		const afterIconHtml = this.generateIconHtmlOrDefaultToEmptyString(el, ":after");
		el.innerHTML = `${beforeIconHtml}${el.innerHTML}${afterIconHtml}`;
	}

	// tested
	private getIconValueOrDefaultToEmptyString(declaration: CSSStyleDeclaration) {
		const contentValue = declaration.content;
		if (typeof contentValue !== "string") {
			return "";
		}
		const contentValueWithoutQuotes = contentValue.replace(/("|')/gi, "");
		const match = /^use(#[a-zA-Z0-9_-]+)$/gi.exec(contentValueWithoutQuotes);
		if (match !== null) {
			return match[1];
		}
		return "";
	}

	// tested
	private generateIconHtmlOrDefaultToEmptyString(el: HTMLElement, pseudoElement: ":before" | ":after") {
		const cssDeclarations = this.windowHelper.getComputedStyle(el, pseudoElement);
		const spriteValue = this.getIconValueOrDefaultToEmptyString(cssDeclarations);
		if (spriteValue === "") {
			return spriteValue;
		}
		return this.generateIconHtml(spriteValue);
	}

	// tested
	private generateIconHtml(icon: string) {
		return `<svg class="svg-icon--large"><use xlink:href=${icon}></use></svg>`;
	}
}
